module.exports = __webpack_public_path__ + "img/oufu_122x141x11_8b.prt.c71d26a5.jpg";